<template>
    <div class="snapshot_pc template4" :style="containerStyle">
        <div v-show="showMarketReportData || showMarketComing">
            <div class="board_container">
                <div class="board">
                    <board-card
                        :params="soldListing"
                        style="width: 300px"
                        :hasRecentSold="hasRecentSold"
                    />
                    <board-card
                        :params="avgSalePrice"
                        style="width: 300px"
                        :hasRecentSold="hasRecentSold"
                    />
                    <board-card
                        :params="avgDaysOnMarket"
                        :hasRecentSold="hasRecentSold"
                        style="width: 300px"
                    />
                </div>
                <div
                    class="loading_container"
                    v-show="showMarketReportLoading || showMarketComing"
                >
                    <Loading />
                </div>
            </div>
        </div>
        <!-- <div class="coming_container" v-show="showMarketComing">
            <img
                class="pic"
                src="//static.chimeroi.com/image/snapshot/v4-img-no-market@2x.png"
                alt=""
            />
            <div class="desc">coming soon</div>
        </div> -->
        <div class="location_tips_container" v-show="showMarketNoLocation">
            <img
                class="pic"
                src="//static.chimeroi.com/image/snapshot/v4-img-no-market@2x.png"
                :alt="$t('md-snapshot-search.pleaseInputAValid')"
            />
            <div class="desc">
                {{ $t('md-snapshot-search.pleaseInputAValid') }}
            </div>
        </div>
        <div class="no_data" v-show="showMarketNoData">
            <img
                class="pic"
                src="//static.chimeroi.com/image/snapshot/v4-img-no-market@2x.png"
                :alt="noDataText"
            />
            <div class="desc">
                {{ noDataText }}
            </div>
        </div>
    </div>
</template>

<script>


import { mapState } from '@/store/helpers';


import BoardCard from '../board-card';
import Loading from '../../../../../components/loading';

import MoreBtnCommon from '../../../_mixins/more-btn/common';

export default {
    name: 'SnapshotPc',
    components: { 'board-card': BoardCard, Loading },
    mixins: [MoreBtnCommon],
    props: {
        soldListing: {
            required: true
        },
        avgSalePrice: {
            required: true
        },
        avgDaysOnMarket: {
            required: true
        }
    },
    computed: {
        ...mapState({
            "showMarketReportData": "showMarketReportData",
            "showMarketReportLoading": "showMarketReportLoading",
            "showMarketNoLocation": "showMarketNoLocation",
            "showMarketComing": "showMarketComing",
            "showMarketNoData": "showMarketNoData"
        }),
        // container  style of
        containerStyle() {
            return { height: `${this.needMore ? 288 : 202}px` };
        },
        hasRecentSold() {
            return this.soldListing?.status !== 3;
        }
    }
};
</script>

<style lang="scss">
.snapshot_pc.template4 {
    font-family: var(--font-normal);
    padding-top: 0.1px;
    /*  Layout related  start */
    .board_container {
        position: relative;
        .board {
            padding: 30px 0;
            display: flex;
            gap: 20px;
            .board_card {
                flex: 1;
            }
        }
        .loading_container {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: var(--level-low);
            background: rgba(255, 255, 255, 0.6);
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
    /*  Layout related  end */
    .more {
        margin: 30px auto;
        width: 332px;
        height: 40px;
        border-radius: 2px;
        background-color: var(--color-theme);
        font-size: 16px;
        font-weight: 600;
        color: #ffffff;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        p {
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .button {
            width: 100%;
        }
    }
    .coming_container,
    .location_tips_container,
    .no_data {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .pic {
            width: 220px;
            height: 130px;
        }
        .desc {
            margin-top: 20px;
            font-size: 16px;
            padding: 0 20px;
            text-align: center;
            color: var(--color-holder);
        }
    }
}

</style>
